import { Country } from '~/Api/Country';

import DataSource from './DataSource';
import RequiredLicenses from './RequiredLicenses';

export interface RawDataSource {
	type: string;
	shortName: string;
	description: string;
	country: {
		alpha2: string;
		name: string;
	};
	requiresLicence: { prices: boolean };
}

export default function mapDataSource(dataSource: null): null;
export default function mapDataSource(dataSource: RawDataSource): DataSource;
export default function mapDataSource(dataSource: RawDataSource | null): DataSource | null {
	if (!dataSource) {
		return null;
	}

	return new DataSource(
		dataSource.type,
		dataSource.shortName,
		dataSource.description,
		new Country(dataSource.country.alpha2, dataSource.country.name),
		new RequiredLicenses(dataSource.requiresLicence.prices)
	);
}
